import {
 Select
} from '@usap/uicomponents'
import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']

export const SelectOptionsWMO = styled(Select)`
  font-weight: normal;
  padding: 11px;
  background: transparent;
  border-radius: 4px;
  margin: 0;
  line-height: 20px;
  border: none;
  font-size: 14px;
  cursor: ${(props) => props.disabled ? 'unset' : 'pointer'};
  color: ${darkColor};
  width: 100%;
`
